<form [formGroup]="form" class="popup-map-form">
    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title> Información  </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="data-form">
                <div class="row field-row">
                    <mat-label class="col">ID</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="zonaExclusionId" matInput
                               type="number"
                               [readonly]="true" />
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>
        
    </mat-accordion>    
</form>

<div class="btn-contenedor mt-3">
    <button (click)="onCancel()" color="warn" mat-raised-button>Cancelar</button>
</div>
